export const validateFile = (sizeInMb, acceptedFiles) => (file) => {
  if (file.size > sizeInMb * 1024 * 1024) {
    return {
      code: 'size-too-large',
      message: 'File too large'
    };
  }

  if (!acceptedFiles.includes(file.type)) {
    return {
      code: 'file-invalid-type',
      message: 'Unsupported file'
    };
  }

  return null;
}

export const formatSize = (bytes) => {
  if (bytes >= 1024 * 1024) {
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  } else if (bytes >= 1024) {
    return (bytes / 1024).toFixed(2) + ' KB';
  } else {
    return bytes + ' B';
  }
};